import { render, staticRenderFns } from "./SearchComp.vue?vue&type=template&id=7928c860"
import script from "./SearchComp.vue?vue&type=script&lang=js"
export * from "./SearchComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports